module.exports = __webpack_public_path__ + "static/media/shopDoor.d9e8fc7a.mp3";